import { render, staticRenderFns } from "./PinterestFeed.vue?vue&type=template&id=191d75a9&"
import script from "./PinterestFeed.vue?vue&type=script&lang=js&"
export * from "./PinterestFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports